const translations = {
  en: {
    Assignee: 'Assigned to',
    WorkOrderType: 'Work order type',
    ItemToRepair: 'Item to repair',
    Room: 'Location',
    AppointmentDate: 'Appointment date',
    RequestType: 'Request type',
    ContactInformation: 'Contact information',
    LastResolvedDate: 'Last resolved date',
    LastClosedDate: 'Last closed date',
    Title: 'Summary'
  }
};

export default translations;




// WEBPACK FOOTER //
// ./src/constants/translations.js